module.exports = __webpack_public_path__ + "static/media/Other Types of Stations.a29308c6.svg";